import './account.css';
import { Component, h, state, css, page, signal, Fragment } from 'pylevate-runtime';
import { getMe, logout } from '../api.js';
import { Nav } from '../components/nav.js';
export class Account extends Component {
  constructor(...args) {
    super(...args);
    this._email = signal('');
    this._name = signal('');
  }
  get email() { return this._email.value; }
  set email(v) { this._email.value = v; }
  get name() { return this._name.value; }
  set name(v) { this._name.value = v; }
  async componentDidMount() {
    let me = await getMe();
    if (!__truthy(me['signed_in'])) {
      window.location.href = '/api/auth/login?next=/account';
      return;
    }
    this._email.value = me['account']['email'];
    this._name.value = me['account']['name'] || '';
  }
  signout() {
    logout();
  }
  render(props, state, context) {
    const children = props && props.children;
    return h('div', null, h(Fragment, null, h(Nav, {email: this._email.value}), h('div', {className: 'wrap-06d433'}, h(Fragment, null, h('div', {className: 'card-06d433'}, h(Fragment, null, h('h3', null, 'You'), h('div', {className: 'kv-06d433'}, h(Fragment, null, h('span', null, 'Name'), h('b', null, `${this._name.value || "—"}`), h('span', null, 'Email'), h('b', null, `${this._email.value}`))))), h('a', {className: 'card-06d433 go-06d433', href: '/workspaces'}, h(Fragment, null, h('div', null, h(Fragment, null, h('h3', null, 'Workspaces'), h('p', null, 'Create, share and delete workspaces; wake, keep awake; usage and costs.'))), h('span', {className: 'arrow-06d433'}, '→'))), h('a', {className: 'card-06d433 go-06d433', href: '/keys'}, h(Fragment, null, h('div', null, h(Fragment, null, h('h3', null, 'API keys'), h('p', null, 'Keys for scripts and MCP clients to reach your workspaces.'))), h('span', {className: 'arrow-06d433'}, '→'))), h('button', {className: 'btn-06d433', onClick: this.signout.bind(this)}, 'Sign out')))));
  }
}
Account = page({title: 'Account — eutonomous', route: '/account'})(Account);
